<template>
	<div>
		<div class="yqclass">
			<div v-for="(i) in list" :key="i" class="yqclass1">
				<div class="yqclass1_1">
					<img :src="i.serveUser.avatar" alt="" srcset="" class="yqclass1img" />
					<div class="yqclass1_2">
						<div class="yqclass1_title">
							<div>{{i.serveUser.nickname}}</div>
							<span>合作次数：{{i.order_num}}</span>
						</div>
						<div class="yqclass1_box">
							<div>
								<img src="@/assets/caller.png" alt="" sizes="" srcset="" v-for="(i) in i.serveUser.display_score" />
								<span>{{i.serveUser.display_score}}</span>
							</div>
							<el-divider direction="vertical"></el-divider>
							<div>
								接单：{{i.serveUser.total_order_num}}
							</div>
							<el-divider direction="vertical"></el-divider>
							<div>
								售后：{{i.serveUser.aftersale_num}}
							</div>
						</div>
					</div>
				</div>
				<div class="QRyb">
					<div @click="queding(i.serve_uid)">确认邀标</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="提示"
		  :visible.sync="logVisible"
		  width="450px"
		  center>
		  <div>
			  每个需求只能邀请一位服务方，您确定邀请这位服务方吗
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="logVisible = false">取 消</el-button>
		    <el-button type="primary" @click="subment">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	// import YqList from '@/common/YqList.vue';
	import { DemandInviteAdd } from '@/api/api'
	export default {
	  name: 'HelloWorld',
	  components:{
		// YqList  
	  },
	  data() {
	    return {
		   logVisible:false,
		   serve_uid:""
	    }
	  },
	  props:{
		 list:{},
		 d_id:{}
	  },
	  methods: {
		  subment(){
			  DemandInviteAdd({
				  d_id:this.d_id,
				  serve_uid:this.serve_uid
			  }).then(res=>{
				  if(res.data.status==200){
			          this.logVisible=false
					   this.$message.success("邀请成功！")
					  setTimeout(() => {
					        this.$router.go(-1);
					  },1500);
				  }
			  })
		  },
		  queding(serve_uid){
				this.serve_uid=serve_uid
				this.logVisible=true
		  }

	  },
	}
</script>
<style scoped>
	.yqclass{
		width:1200px;
		margin:0 auto;
		display:flex;
		flex-wrap:wrap;
	}
	::v-deep .el-dialog__body{
		border-top:1px solid rgba(30,58,138,0.15);
	}
	.yqclass1{
		width: 384px;
		height: 140px;
		background: #FFFFFF;
		border-radius: 12px ;
		padding:12px;
		box-sizing: border-box;
		margin-right:24px;
		margin-bottom:20px;
	}
	.yqclass>div:nth-child(3n){
		margin-right:0px;
	}
	.yqclass1img{
		width:52px;
		height:52px;
		border-radius:50%;
		margin-right:10px;
	}
	.yqclass1_1{
		width:100%;
		display:flex;
		align-items:center;
	}
	.yqclass1_title{
		display:flex;
		width:300px;
		justify-content:space-between;
		align-items: center;
	}
	.yqclass1_title div{
		width: 200px;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.yqclass1_title span{
		font-weight: bold;
		font-size: 14px;
		color: #1E3A8A;
	}
	.yqclass1_box{
		display:flex;
		align-items: center;
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.yqclass1_box div{
		display:flex;
		align-items:center;
	}
	.yqclass1_box img{
		width:14px;
		height:14px;
		margin-right:2px;
	}
	.QRyb{
		width:100%;
		display:flex;
		justify-content:center;
		margin-top:28px;
	}
	.QRyb div{
		width: 200px;
		height: 32px;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid rgba(30,58,138,0.2);
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
		cursor:pointer;
		transition: all 0.3s;
	}
	.QRyb div:hover{
		background-color: #1E3A8A !important;
		color:#fff !important;
		transition: all 0.3s;
	}
</style>